import './LandingPage.scss';

// Components
import './LandingReviewsCarousel/LandingReviewsCarousel';
import '../Components/Location/Location.scss';
import '../Components/Location/LocationMap/LocationMap';
import '../Components/HighLight/HighLight.scss';
import '../Components/SimpleText/SimpleText.scss';
import '../Components/CallForm/CallForm/CallForm';
import '../Components/CallForm/CallForm.scss';

import ModalVideo from '../Shared/ModalVideo/ModalVideo';

const video = new ModalVideo();
video.init();


// WEBPACK FOOTER //
// ./Src/LandingPage/LandingPage.js